import { authToken } from './settings.js';
import { fetchRetry } from './Network.js';
import { getConfig } from '../utils/configUtils';
import { TASK_STATUS, TASK_TAG } from '../constants/Tasks.js';
import { getUnitName, shortId } from './lib.js';
import { getUseFirestore } from '../constants/Meta';
import { clearFetch } from './Utils';
import { elasticLogEvent, elasticLogError } from './ElasticLog';


export default class TaskRequest {
  /**
   * Uses the known hostname to call an endpoint.
   *
   * @param {str} logLabel - context for logging
   * @param {str} method - the type of HTTP request being made
   * @param {str} endpoint - the endpoint being called
   * @param {dict} payload - the request body (if any); will be JSON.string-ified by this routine.
   *
   * @return {dict} - the api call result in JSON
   */
  static async _callDiligentApi(logLabel, method = 'GET', endpoint, payload = null) {
    const url = getConfig().diligentApiHost + endpoint;

    let options = {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-token': authToken,
      },
      body: payload ? JSON.stringify(payload) : undefined,
    };

    let response = await fetchRetry(logLabel, url, options);
    return response.json();
  }

  /**
   * Asks for a task to be made via the DiligentAPI.
   *
   * Note: This will not start the task. Task must be confirmed
   *
   * @param {str} requesterId - id of tablet making request
   * @param {str} taskType - the task type being requested
   * @param {dict} taskArgs - the task arguments for the task being requested
   * @param {dict} taskData - the task data for the task being requested
   * @param {bool} isStat - whether this task is urgent or not
   *
   * @returns {dict} - the resquest result in JSON
   */
  static async request(requesterId, taskType, requiredRole_UNUSED, taskArgs, taskData, isStat) {
    let result = await TaskRequest._callDiligentApi('TaskRequest.request', 'POST', '/tasks/request', {
      requester_id: requesterId,
      task_type: taskType,
      task_args: taskArgs,
      task_data: taskData,
      is_stat: isStat,
    });

    return result;
  }

  // /**
  //  * Asks for batch tasks to be created via the task-service.
  //  *
  //  * @param {Object[]} tasks - payload of task objects
  //  *
  //  * @returns {dict} - the resquest result in JSON
  //  */
  // static async batchRequest(tasks) {
  //   return await TaskRequest._callDiligentApi('TaskRequest.batchRequest', 'POST', '/tasks/batch', tasks);
  // }

  // /**
  //  * Confirms a task request.
  //  * @param {str} uuid - the uuid of the task being confirmed
  //  * @returns {dict} - the request result in JSON
  //  */
  // static async confirm(uuid) {
  //   return await TaskRequest._callDiligentApi('TaskRequest.confirm', 'POST', '/tasks/confirm/{}'.replace('{}', uuid));
  // }

  /**
   * Cancels a task request.
   * @param {str} uuid - the uuid of the task being canceled
   * @returns {dict} - the request result in JSON
   */
  static async cancel(uuid) {

    if(!getUseFirestore()) {
      //do this through mbotSvc
      return await TaskRequest.mbotCancelTasks([uuid]);
    }
    else {
      //do this via the scheduler directly (legacy)
      let response = await TaskRequest._callDiligentApi('TaskRequest.cancel', 'POST', `/tasks/cancel/${uuid}`);
      if(!response)
        return {error: 'Cancel failed'};
      return { success:true };
    }
  }



  // /**
  //  * Retrieves tasks from scheduler.
  //  *
  //  * @returns {dict} - the request result in JSON
  //  */
  // static async get() {
  //   return await TaskRequest._callDiligentApi('TaskRequest.get', 'GET', '/tasks?limit=100&steps=true&actions=false');
  // }



  static async mbotCancelTasks(uuidArr) {

    let options = {
      method: 'PUT',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({uuids:uuidArr})
    };

    let result;
    await clearFetch(`${getConfig().uiSimServer}/cancelTasks`, options, {
      success: (json) => {
        result = {success:true};
      },
      bad: ({ logStr }) => {
        elasticLogError({ what: 'cancelTasksErr', msg: `Error cancelling ${uuidArr.map(uuid => shortId(uuid)).join(', ')}: ` + logStr });
        result = {error: logStr};
      }
    });

    return result;
  }
}
